import React from "react";
import { cn } from "../../lib/utils";
import { THEME_PREFERENCES, type ThemePreference } from "@toolkit/design";
import { useTheme } from "./ThemeProvider";

const LABELS: Record<ThemePreference, string> = {
  light: "Light",
  dark: "Dark",
  system: "System",
};

export const ThemeToggle: React.FC<{ className?: string }> = ({
  className,
}) => {
  const { preference, setPreference } = useTheme();

  return (
    <div
      className={cn(
        "inline-flex rounded-lg border border-border bg-card p-1",
        className,
      )}
      role="group"
      aria-label="Color theme"
    >
      {THEME_PREFERENCES.map((option) => {
        const selected = preference === option;
        return (
          <button
            key={option}
            type="button"
            aria-pressed={selected}
            onClick={() => setPreference(option)}
            className={cn(
              "rounded-md px-3 py-1.5 text-xs font-semibold transition-colors",
              selected
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {LABELS[option]}
          </button>
        );
      })}
    </div>
  );
};
